import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Button } from "./Button";
import { Modal, ModalActions } from "./Modal";

export type ConfirmModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  description?: React.ReactNode;
  icon?: IconProp;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  maxWidth?: "sm" | "md" | "lg" | "xl";
};

export const ConfirmModal = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  description,
  icon = "info-circle",
  confirmLabel = "CONFIRMER",
  cancelLabel = "ANNULER",
  loading = false,
  maxWidth = "sm",
}: ConfirmModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      icon={icon}
      maxWidth={maxWidth}
    >
      <div className="space-y-4 leading-relaxed">
        {description && <div className="text-default-text">{description}</div>}
        <ModalActions>
          <Button type="button" variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button type="button" onClick={onConfirm} disabled={loading}>
            {loading ? "ENVOI EN COURS..." : confirmLabel}
          </Button>
        </ModalActions>
      </div>
    </Modal>
  );
};
